import React from 'react';
import { volumes } from '../data/content';
export function WhatsInside() {
  return <section id="contenu" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-187" data-mp="yvqx52trblli">
      <div className="mx-auto max-w-3xl" data-id="element-188" data-mp="ytobeuzn0eml">
        <div className="text-center" data-id="element-189" data-mp="kx0znm30zjwm">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-190" data-mp="kvzqxo9hf9i2">
            6 volumes numériques · PDF haute résolution
          </span>
          <h2 className="mt-4 font-display text-[1.75rem] font-black leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-191" data-mp="b5dfm68st556">
            <span aria-hidden="true" data-id="element-192" data-mp="fyptpmfuptjo">🏀 </span>Que contient le pack{' '}
            <span className="italic text-grape" data-id="element-193" data-mp="26t35mttzrpe">Basketball Prêt™ ?</span>
          </h2>
        </div>

        <ol className="mt-12 grid gap-4 sm:grid-cols-2" data-id="element-194" data-mp="75w7f51zltwb">
          {volumes.map(volume => <li key={volume.number} className="flex items-start gap-4 rounded-2xl bg-cream px-5 py-5" data-id="element-195" data-mp="3odzo08di1ugw">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-navy font-display text-sm font-bold text-white" data-id="element-196" data-mp="3te5o8cxu4pal">
                {volume.number.toString().padStart(2, '0')}
              </span>
              <div data-id="element-197" data-mp="3luc7g1cc228m">
                <h3 className="font-display text-base font-bold text-navy" data-id="element-198" data-mp="3luvo7eq8ykl2">
                  <span className="text-grape" data-id="element-199" data-mp="3hta8zmq8pu7p">
                    Volume {volume.number.toString().padStart(2, '0')}
                  </span>
                  <span aria-hidden="true" className="text-navy/30" data-id="element-200" data-mp="2u3xzsmuwxm5e">
                    {' '}
                    —{' '}
                  </span>
                  {volume.title}
                </h3>
                <p className="mt-1.5 text-xs leading-relaxed text-navy/55" data-id="element-201" data-mp="32xb22feva045">
                  {volume.text}
                </p>
              </div>
            </li>)}
        </ol>

        <p className="mt-10 text-center text-xs font-semibold text-navy/50" data-id="element-202" data-mp="2ae4emrmpe5a5">
          De U7 à Seniors · Ouvrez, suivez le plan et entraînez.
        </p>
      </div>
    </section>;
}